// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__1WHGS","Open":"SideDrawer_Open__27eJq","Close":"SideDrawer_Close__1V6mV","Logo":"SideDrawer_Logo__nHV5m"};